<template>
  <div class="container">
    <head-nav-bar title="我的报告" :fixed="true" @click-left="back" />
    <div class="list mt-header-nav">
      <ContactCard v-model="contact" @change="onContactChange" />
      <div class="kong"></div>

      <van-tabs
        v-model="tabActive"
        @change="onTabChange"
        sticky
        :offset-top="46"
        style="width:100%;"
      >
        <van-tab name="2" title="检验报告"> </van-tab>
        <van-tab name="1" title="检查报告" v-if="!unEnabledMyExamReport">
        </van-tab>
      </van-tabs>
      <DataList :data="list" ref="dataList" v-if="!loadding">
        <template v-slot:item="item">
          <van-cell is-link @click="toInfo(item.obj)" title-style="flex:3;">
            <div slot="title">
              <div>
                <b>单号</b>
                ：{{ item.obj.reqNo }}
              </div>
              <div>
                <b>{{ tabActive == 2 ? "检验目的" : "检查目的" }}</b>
                ：{{ item.obj.purpose }}
              </div>
              <div>
                <b>{{ tabActive == 2 ? "检验日期" : "检查日期" }}</b>
                ：{{ item.obj.date }}
              </div>
            </div>
            <van-icon
              slot="right-icon"
              name="arrow"
              style="line-height: 2rem;"
            />
          </van-cell>
        </template>
      </DataList>
      <van-loading size="24px" v-if="loadding" vertical class="vanloading"
        >加载中...</van-loading
      >
    </div>
  </div>
</template>

<script>
import { List, Tag, Button, Icon, Cell, Tab, Tabs, Loading } from "vant";
import DataList from "@/components/DataList";
import ContactCard from "@/components/ContactCard";

export default {
  name: "userReportList",
  components: {
    DataList,
    ContactCard,
    [List.name]: List,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Loading.name]: Loading,
  },
  data() {
    return {
      isFinish: false,
      contact: {},
      list: [],
      tabActive: null,
      unEnabledMyExamReport: false,
      params: {},
      disabled: false,
      loadding: false,
    };
  },
  created() {
    const query = this.$route.query;
    if (query && query.tab == "2") {
      this.tabActive = "1";
    } else {
      this.tabActive = "2";
    }
    setTimeout(() => {
      this.$post("GetWxSystemParameterInfo", {}).then((res) => {
        this.unEnabledMyExamReport = res.data.unEnabledMyExamReport;
        this.getData();
      });
    }, 1000);
  },
  methods: {
    getData() {
      this.loadding = true;
      const that = this;
      this.list = [];
      this.params = {
        DiagnosisCardNo: this.contact.diagnosisCardNo,
        ReportType: this.tabActive,
      };
      this.$post("MyReport_List", this.params)
        .then((res) => {
          this.list = res.data.datas;
          this.loadding = false;
        })
        .finally(() => {});
      // setTimeout(() => {
      //   that.list = this.tabActive == 1 ? [] : [{}];
      //   this.loadding = false;
      // }, 1000);
    },
    toInfo(item) {
      if (this.tabActive == "1") {
        this.$router.push({
          name: "userReportInfo",
          query: {
            Id: item.reportId,
            ReqNo: item.reqNo,
            type: this.tabActive,
          },
        });
      } else {
        this.$router.push({
          name: "userReportInspectionInfo",
          query: {
            Id: item.reportId,
            ReqNo: item.reqNo,
            type: this.tabActive,
          },
        });
      }
    },
    //切换就诊人
    onContactChange() {
      this.getData();
    },
    onTabChange(type) {
      this.params.ReportType = type;
      this.getData();
    },
    back() {
      this.$router.push({
        name: "userIndex",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.list-item {
  .value {
    line-height: 2.3rem;
    color: #333;
    font-size: 0.5rem;
  }
  .van-cell__title {
    flex: 2;
  }
}
.vanloading {
  text-align: center;
  margin-top: 20px;
}
</style>
